import React, { FC, useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { CircularProgress, makeStyles, TextField } from '@material-ui/core';
import axios from 'axios';

import { addParam, Form, FormKeysUnion } from 'modules/search/Search';

type Props = {
	id: FormKeysUnion;
	name: FormKeysUnion;
	label: string;
	value?: string;
	disabled: boolean;
	helperText?: string;
	formValues: Form;
	onChange: (
		field: string,
		value: unknown,
		shouldValidate?: boolean | undefined,
	) => void;
};

const useStyles = makeStyles(() => ({
	field: {
		width: '225px',
		margin: '10px',
	},
}));

const FormikAutocomplete: FC<Props> = ({
	id,
	name,
	label,
	value,
	disabled,
	formValues,
	helperText,
	onChange,
}) => {
	const [options, setOptions] = useState<string[]>([]);

	const [loading, setLoading] = useState<boolean>(false);

	const [open, setOpen] = useState<boolean>(false);

	const classes = useStyles();

	const getFilterQuery = (values: Form) => {
		let params = '';

		for (const key in values) {
			params = addParam(params, key, values[key], '%');
		}

		return params;
	};

	useEffect(() => {
		load(formValues, name);
	}, [formValues[name]?.length]);

	const load = async (formValues: Form, fieldName: FormKeysUnion) => {
		if (!formValues[fieldName]?.length) return;

		setLoading(true);

		let url = `/api/scitacioperaty/search/field/${name}`;

		const filterQuery = getFilterQuery(formValues);

		if (filterQuery?.length) {
			url += filterQuery;
		}

		const encodedUrl = encodeURI(url);

		try {
			axios.post(encodedUrl).then(response => {
				if (response.data) {
					setOptions(response.data.data);
					setLoading(false);
				}
			});
		} catch (e) {
			console.error(e);
		}
	};

	useEffect(() => {
		load(formValues, name);
	}, []);

	const handleChange = (_: unknown, value: string | null) => {
		onChange(name, value);
	};

	return (
		<Autocomplete
			id={id}
			options={options}
			style={{ width: 225 }}
			className={classes.field}
			open={open}
			onOpen={() => setOpen(true)}
			onClose={() => setOpen(false)}
			onChange={handleChange}
			onInputChange={handleChange}
			disabled={disabled}
			size="small"
			loading={loading}
			freeSolo
			value={value}
			renderInput={params => (
				<TextField
					{...params}
					label={label}
					helperText={helperText}
					variant="outlined"
					InputProps={{
						...params.InputProps,
						endAdornment: (
							<>
								{loading ? (
									<CircularProgress color="inherit" size={20} />
								) : null}
								{params.InputProps.endAdornment}
							</>
						),
					}}
				/>
			)}
		/>
	);
};

export default FormikAutocomplete;
